import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export interface AlgoliaSearchParams {
  org_id: string;
  query: string;
  facet_filters: string[][];
  hits_per_page: number;
  page: number;
  created_at_start?: string;
  created_at_end?: string;
  date_of_service_start?: string;
  date_of_service_end?: string;
  date_of_work_start?: string;
  date_of_work_end?: string;
}

export const algoliaSearch = async (
  params: AlgoliaSearchParams,
): Promise<any> => {
  const bearerToken = await getBearerToken();

  const raw = JSON.stringify({
    org_id: params.org_id,
    query: params.query,
    facet_filters: params.facet_filters,
    hits_per_page: params.hits_per_page,
    page: params.page,
    created_at_start: params.created_at_start,
    created_at_end: params.created_at_end,
    date_of_service_start: params.date_of_service_start,
    date_of_service_end: params.date_of_service_end,
    date_of_work_start: params.date_of_work_start,
    date_of_work_end: params.date_of_work_end,
  });

  const requestOptions: RequestInit = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearerToken}`,
    },
    body: raw,
  };

  try {
    const response = await fetch(API_ENDPOINTS.ALGOLIA_SEARCH, requestOptions);
    const result = await response.text();
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
